import { BigNumber } from '@ethersproject/bignumber';
import { BigNumberWithDecimals, ChecksumAddress } from '@silo/types';
import { LTV } from 'app/features/util/ltv';

type GetLtvLimit = (currentLTV: LTV | null, assetAddress: ChecksumAddress) => BigNumberWithDecimals | null;

export const getLtvLimit: GetLtvLimit = (currentLTV, assetAddress) => {
  if (!currentLTV) return null;

  const collateralAssetMetrics = currentLTV.collateralAssetsMap[assetAddress];

  /**
   * TODO: figure out why this check is necessary. Without, there is an
   * error thrown for a full withdrawal with multiple collateral (need to be
   * borrowing too)
   *
   * It's some kind of race condition in the render cycle once the full
   * withdrawal finishes.
   */
  if (!collateralAssetMetrics) {
    return null;
  }

  const {
    decimals,
    maxWithdrawTokens: { type, value },
  } = collateralAssetMetrics;

  if (type === 'protocolBalance') return null;

  return {
    decimals,
    bigNumber: BigNumber.from(value),
  };
};
